import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classnames } from '../../../utils/classnames';

class RightNav extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    navListView(list = []) {
        return list.map((item, index) => {
            return (
                <a key={index} className={styles.item} href={item.url} target="_blank" rel={relText}>
                    <i className={styles.dian} />
                    {item.title}
                </a>
            );
        });
    }
    render() {
        const { content } = this.props;

        return <div className={styles.rightnav}>{this.navListView(content)}</div>;
    }
}

export default RightNav;
